/**
 * Deep J: two amoeba pits under one long creeper vein. Run the whole vein and its wall seals both
 * pits; the amoebas fill them and turn to diamonds. Leave it too long and they climb out and
 * overgrow the cave (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepJ: CaveDef = {
  id: 'J',
  name: 'OVERGROWTH',
  hint: 'One run along the vein seals both pits. Go now.',
  intermission: false,
  colors: [9, 13, 5],
  diamondValue: 22,
  extraValue: 40,
  amoebaTime: 25,
  fill: { base: '.', items: [['r', 10], ['d', 5]] },
  levels: [
    { seed: 6001, diamonds: 20, time: 150 },
    { seed: 6002, diamonds: 25, time: 140 },
    { seed: 6003, diamonds: 30, time: 130 },
    { seed: 6004, diamonds: 35, time: 120 },
    { seed: 6005, diamonds: 40, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W??????????????????????????????????????W',
    'W..P.??????????????????????????????????W',
    'W....??????????????????????????????????W',
    'W...???????????????????????????????????W',
    'Ww.wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwW',
    'Wx..d..d...d..d...d..d...d..d.d..d.....W',
    'Wwwwww........wwwwwwwwwwww........wwww.W',
    'W????w........w??????????w........w????W',
    'W????w........w??????????w........w????W',
    'W????w........w??????????w........w????W',
    'W????w...a....d.????????.d...a....w????W',
    'W????wwwwwwwwwW??????????Wwwwwwwwww????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W?????????????????????????????????.....W',
    'W?????????????????????????????????...X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
